<template>
  <div class="login">
    <div class="bgMp4">
      <img src="/static/picture/kr_login_bg.png" alt width="100%" height="100%" />
    </div>
    <div class="systemWindow">
      <div class="logo">
        <img :src="env.LOGIN_FORM_LOGO" alt />
      </div>
      <div class="title_module">
        <div class="title">一站式保函办理服务平台</div>
        <div class="img">
          <img src="/static/picture/kr_version.png" alt />
        </div>
      </div>
      <ul>
        <li>银行保函</li>
        <li>|</li>
        <li>公司出函</li>
        <li>|</li>
        <li>无中间差价</li>
        <li>|</li>
        <li>最快24小时出换</li>
        <li>|</li>
        <li>真实性可查</li>
      </ul>
    </div>
    <div class="loginWindow">
      <div class="loginTile">
        <div class="wocomeName">— 欢迎登录 —</div>
        <div class="name">{{ env.LOGIN_FORM_TITLE }}</div>
      </div>
      <div class="loginForm">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item label="User Name" prop="userName">
            <el-input
              class="loginName"
              placeholder="请输入账号"
              type="text"
              v-model="ruleForm.userName"
              @keyup.native.enter="loginEvent()"
            >
              <template slot="prefix">
                <i class="el-icon-loginyonghu"></i>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="Password" prop="passWord">
            <el-input
              class="loginPassWord"
              placeholder="请输入密码"
              :type="flag ? 'text' : 'password'"
              v-model="ruleForm.passWord"
              @keyup.native.enter="loginEvent()"
            >
              <template slot="prefix">
                <i class="el-icon-mima"></i>
              </template>
              <template slot="suffix">
                <i
                  :class="flag ? 'el-icon-loginzhengyan' : 'el-icon-loginbiyan'"
                  @click="flag = !flag"
                ></i>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
        <el-button class="loginSubmit" type="primary" @click="loginEvent" :loading="loginLoad">登 录</el-button>
        <div class="version">{{env.COPYRIGHT}}版权所有 版本：{{ env.VERSION }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from "./mixin";
export default {
  name: "login",
  mixins: [mixin]
};
</script>
<style scoped lang="less">
@keyframes windowAnimation {
  from {
    top: 60%;
    opacity: 0;
  }
  to {
    top: 50%;
    opacity: 1;
  }
}
.login {
  position: relative;
  .bgMp4 {
    height: 100vh;
    display: flex;
    justify-content: center;
    // background: #222536;
    overflow: hidden;
  }
  .systemWindow {
    position: absolute;
    top: 10%;
    left: 162px;
    .logo {
      margin-bottom: 32px;
      width: 196px;
      height: 56px;
      img {
        height: 100%;
      }
    }
    .title_module {
      font-size: 44px;
      font-weight: bold;
      margin-bottom: 16px;
      position: relative;
      .img {
        position: absolute;
        top: -20px;
        right: 0;
        width: 71px;
        height: 36px;
      }
    }
    ul {
      font-size: 18px;
      display: flex;
      align-items: center;
      gap: 10px;
      list-style: none;
    }
  }
  .loginWindow {
    width: 400px;
    height: 512px;
    background: #ffffff;
    box-shadow: 0px 3px 12px rgba(37, 38, 44, 0.08);
    border-radius: 20px;
    position: absolute;
    top: 50%;
    right: 198px;
    transform: translateY(-55%);
    padding: 0 40px;
    animation: windowAnimation 1s;
    .loginTile {
      padding-top: 64px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .wocomeName {
        font-size: 24px;
      }
      .name {
        font-size: 16px;
        color: #000;
        margin-top: 8px;
      }
    }
    .loginForm {
      margin-top: 32px;
      .el-form-item {
        margin-bottom: 20px;
      }
      .loginName,
      .loginPassWord {
        /deep/ .el-input__inner {
          background: #f7f9fc;
          border-radius: 8px;
          padding: 0 48px;
        }
      }
      .loginSubmit {
        width:100%;
        background: #e62129;
        border-color:#e62129;
        margin-top: 12px;
      }
      .version {
        font-size: 14px;
        font-weight: 400;
        color: #cccccc;
        margin-top: 64px;
        text-align: center;
      }
      .el-icon-loginyonghu,
      .el-icon-mima {
        font-size: 20px;
        margin-left: 8px;
        margin-top: 10px;
      }
      .el-icon-loginzhengyan,
      .el-icon-loginbiyan {
        font-size: 20px;
        color: #e62129;
        margin-top: 10px;
        margin-right: 8px;
      }
    }
  }
}
</style>
